import { useTranslation } from "react-i18next";
import ModalContainer from "../../containers/Modal/ModalContainer";
import { useEffect, useState } from "react";
import AddNewTagModal from "./AddNewTagModal";
import { TagService } from "../../services/TagService";
import { showWarning } from "../../services/ModalService";
import "./Tags.scss";

export default function TagListModal({ isOpen, closeModal, groups, setIsOpen }) {
  let { t } = useTranslation();
  const [tagList, setTagList] = useState([]);
  const [tag, setTag] = useState({});
  const [isFormOpen, setIsFormOpen] = useState(false);

  useEffect(() => {
    TagService.getTagsList().then((data) => {
      setTagList(data);
    });
  }, [isFormOpen]);

  function openForm(tag) {
    setTag(tag);
    setIsFormOpen(true);
    closeModal();
  }

  function closeForm() {
    setTag({});
    setIsFormOpen(false);
  }

  function deleteTag(id) {
    showWarning("Are you sure you want to delete this tag?", () => {
      TagService.deleteTag(id).then(() => {
        TagService.getTagsList().then((data) => {
          setTagList(data);
        });
      });
    });
  }

  const reopenModalTagList = () => {
    setIsFormOpen(false);
    setIsOpen(true);
  };
  
  return (
    <>
      <ModalContainer
        isOpen={isOpen}
        modalTitle={t("Tags List")}
        closeModal={closeModal}
        crossmarkAction={closeModal}
        closeButtonTitle="Close"
        modalSize="lg"
        closeButtonAction={closeModal}
        createButtonAction={() => openForm(tag)}
        createButtonTitle={t("Create")}
      >
        <div className="table-scroll-height tags-list" id="scroll-desing">        
          <table className="table">
            <thead>
              <tr>
                <th>{t("Tag")}</th>
                <th>{t("Description")}</th>
                <th>{t("Group")}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {tagList.map((tag) => {
                return (
                  <tr>
                    <div>
                      <td className="col-3 tags-background-color" style={{ backgroundColor: tag.color }}>{tag.name}</td>
                    </div>
                    <td className="col-3" style={{ width: "45%" }}>{!tag.description ? "-" : tag.description}</td>
                    <td className="col-3" style={{ width: "18%" }}>{!tag.groupName ? "-" : tag.groupName}</td>
                    <td className="col-3 buttons-hover" style={{ width: "18%" }}>
                      <button
                        onClick={() => openForm(tag)}
                        className="action-button"
                      >
                        <span>
                          <i class="bi bi-pencil-square"></i>
                        </span>
                      </button>
                      <button
                        onClick={() => deleteTag(tag.id)}
                        className="action-button"
                      >
                        <span>
                          <i class="bi bi-trash"></i>
                        </span>
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </ModalContainer>
      <AddNewTagModal
        isOpen={isFormOpen}
        closeModal={closeForm}
        tagEdit={tag}
        groups={groups}
        onClose={() => {
          setIsFormOpen(false);
          setIsOpen(true);
        }}
        onSubmmitSuccess={reopenModalTagList}
        modalTitleProp={tag && tag.id ? "Edit Tag" : "New Tag"}
        buttonTitleProp={tag && tag.id ? "Edit" : "Create"}
      />
    </>
  );
}
